import type { DataTableColumn } from './DataTableTypes';

export type Row = {
  id: number;
  phase: string;
  version: string;
  status: string;
  task: number;
};

export type SortKey = 'id' | 'phase' | 'version' | 'status' | 'task';

export type ColumnDef = Omit<DataTableColumn, 'key'> & { key: SortKey };

export const sampleData: Row[] = Array.from({ length: 28 }, (_, i) => {
  const id = 1000 + i;
  const phase = ['UI Design', 'UI Development', 'Accessibility Fixes', 'Bugs & Issues'][i % 4];
  const version = ['I', 'II', 'III'][i % 3];
  const status = ['Sprint Planning', 'In Review', 'Deployed'][i % 3];
  const task = 12 + i * 7;
  return { id, phase, version, status, task };
});

export const PAGE_SIZE_OPTIONS = [5, 8, 10, 15];

export const DEFAULT_TH_TITLES: ColumnDef[] = [
  { title: 'ID', key: 'id', type: 'number' },
  { title: 'Phase', key: 'phase' },
  { title: 'Version', key: 'version' },
  { title: 'Status', key: 'status' },
  { title: 'Task', key: 'task', type: 'number' },
];

export const DEFAULT_PHASE_SORT_KEY: SortKey = 'phase';
export const DEFAULT_STATUS_SORT_KEY: SortKey = 'status';
export const DEFAULT_PHASE_PLACEHOLDER = 'Filter by Phase';
export const DEFAULT_STATUS_PLACEHOLDER = 'Filter by Status';
